const logIfDev = (message: any) => {
  if (process.env.REACT_APP_BUILD_ENV === 'dev') {
    // eslint-disable-next-line
    console.log(message)
  }
}

export default logIfDev
